/* tslint:disable:max-line-length indent no-trailing-whitespace component-selector */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AssetProfileAttributeUpdateDraftListItem, Railcar } from './railcar.model';
import { DataService } from '../../shared/data.service';
import { formatDateOnly } from '../../shared/date-utility';
import { SearchRequest } from '../program-work/search-request.model';
import { SearchResult } from '../program-work/search-result.model';
import { ProgramWork } from '../program-work/program-work.model';
import { SplcLocation } from '../SplcLocation/splcLocation.model';
import { ExpenseType } from './expense-type.enum';
import { RailcarSuperGroup } from './railcarSuperGroup.model';
import { RailcarStatus } from '../railcarStatus/railcar-status.model';
import { CarMarks } from './car-marks.model';
import { RailcarAttribute } from '../shop-portal-management/attribute/attribute.model';

@Injectable({providedIn: 'root'})
export class RailcarService extends DataService<Railcar> {

	constructor(protected httpClient: HttpClient) {
		super(httpClient, 'railcar');
	}

	public getMany(railcarIds: number[], loadFullRailcarData: boolean, includeDraftSEasActive: boolean): Observable<Railcar[]> {
		return this.httpClient.post<Railcar[]>(this.url + '/getMany?loadFullRailcarData=' + loadFullRailcarData + '&includeDraftSEasActive=' + includeDraftSEasActive, railcarIds);
	}

	/**
	 * DB resolution by car mark key: `Initial` + `number` (no space), uppercase — matches `RailcarRepository.GetIdsByCarMarks`.
	 * Used for Asset Profile Attribute Update bulk import (avoids Azure Search).
	 */
	public getRailcarsByCarMarks(marks: string[]): Observable<Railcar[]> {
		return this.httpClient.post<Railcar[]>(this.url + '/getRailcarsByCarMarks', marks ?? []);
	}

	public searchRailcar(searchText: SearchRequest,getAllData: boolean = false): Observable<SearchResult> {
		return this.httpClient.post<SearchResult>(this.url + '/search?getAllData=' + getAllData , searchText);
	}

	public getPrograms(id: number): Observable<ProgramWork[]> {
		return this.httpClient.get<ProgramWork[]>(this.url + '/' + id + '/program');
	}

	public saveRailcar(railcar: Railcar): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url, railcar);
	}
	public updateCarMark(carMark: any): Observable<any> {
		return this.httpClient.post<any>(this.url + '/UpdateCarMark', carMark);
	}
	public enRouteToLease(railcarId: number, enRouteDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/enRouteToLease?railcarId=' + railcarId + '&enRouteDate=' +
			enRouteDate.toLocaleDateString(), null);
	}
  public enRouteToLeaseInBulk(railcarIds: number[], enRouteDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/enRouteToLeaseInBulk?enRouteDate=' +
			enRouteDate.toLocaleDateString(), railcarIds);
	}
  public arriveAtLease(railcarId: number, arrivalDate: Date, splcLocation: SplcLocation): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtLease?railcarId=' + railcarId + '&arrivalDate=' +
			arrivalDate.toLocaleDateString(), splcLocation);
	}
	public arriveAtLeaseInBulk(keyValues: any[], arrivalDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtLeaseInBulk?arrivalDate=' +
			arrivalDate.toLocaleDateString(), keyValues);
	}
	public arriveAtShop(railcarId: number, arrivalDate: Date, requestReceiverForm:boolean  = true): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtShop?railcarId=' + railcarId + '&arrivalDate=' +
		arrivalDate.toLocaleDateString()+ '&requestReceiverForm='+ requestReceiverForm, null);
	}
	public arriveAtShopInBulk(railcarIds: number[], arrivalDate: Date, requestReceiverForm:boolean  = true): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtShopInBulk?arrivalDate=' +
		arrivalDate.toLocaleDateString()+ '&requestReceiverForm='+ requestReceiverForm, railcarIds);
	}
	public enRouteToStorage(railcarId: number, enRouteDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/enRouteToStorage?railcarId=' + railcarId + '&enRouteDate=' +
			enRouteDate.toLocaleDateString(), null);
	}
	public enRouteToStorageInBulk(railcarIds: number[], enRouteDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/enRouteToStorageInBulk?enRouteDate=' +
			enRouteDate.toLocaleDateString(), railcarIds);
	}
	public arriveAtStorage(railcarId: number, arrivalDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtStorage?railcarId=' + railcarId + '&arrivalDate=' +
			arrivalDate.toLocaleDateString(), null);
	}
	public arriveAtStorageInBulk(railcarIds: number[], arrivalDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/arriveAtStorageInBulk?arrivalDate=' +
			arrivalDate.toLocaleDateString(), railcarIds);
	}
	public dispoFromStorage(railcarId: number, dispoDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/dispoFromStorage?railcarId=' + railcarId + '&dispoDate=' +
			dispoDate.toLocaleDateString(), null);
	}
	public dispoFromStorageInBulk(railcarIds: number[], dispoDate: Date): Observable<Railcar> {
		return this.httpClient.post<Railcar>(this.url + '/dispoFromStorageInBulk?dispoDate=' +
			dispoDate.toLocaleDateString(), railcarIds);
	}
	public updateStatusToSold(railcarId: number, soldDate: Date, ownershipId: number): Observable<any> {
		return this.httpClient.post<any>(this.url + '/updateStatusToSold?railcarId=' + railcarId + '&soldDate=' + 
			soldDate.toLocaleDateString() + '&ownershipId=' + ownershipId, null);
	}
	public updateStatusToSoldInBulk(railcarIds: number[], soldDate: Date, ownershipId: number): Observable<any> {
		return this.httpClient.post<any>(this.url + '/updateStatusToSoldInBulk?soldDate=' + 
			soldDate.toLocaleDateString() + '&ownershipId=' + ownershipId, railcarIds);
	}
	public upDateCPDate(cpDate: Date, isReturnDateUpdate: boolean, railcarId: number, currentLeaseAdjId: number, lastLeaseAdjId: number): Observable<any> {
		return this.httpClient.post<any>(this.url +
			`/updateCPDate?cpDate=${formatDateOnly(cpDate)}&isReturnDateUpdate=${isReturnDateUpdate}&railcarId=
			${railcarId}&currentLeaseAdjId=${currentLeaseAdjId}&lastLeaseAdjId=${lastLeaseAdjId}`, null);
	}
	public upDateCPDateInBulk(cpDate: Date, isReturnDateUpdate: boolean, railcars: Railcar[], currentLeaseAdjId: number, lastLeaseAdjId: number): Observable<any> {
		return this.httpClient.post<any>(this.url +
			`/updateCPDateInBulk?cpDate=${formatDateOnly(cpDate)}&isReturnDateUpdate=${isReturnDateUpdate}&currentLeaseAdjId=${currentLeaseAdjId}&lastLeaseAdjId=${lastLeaseAdjId}`, railcars);
     }
	public getCarAssetProfileValues(railcar: Railcar): Observable<RailcarAttribute[]> {
		return this.httpClient.get<RailcarAttribute[]>(this.url + `/GetCarAssetProfile?railcarId=${railcar.id}`); 
	}

	/** Queues bulk persist of asset profile attributes (Azure Function processes process-bulk-job). */
	public queueAssetProfileAttributeUpdate(payload: RailcarAttribute[]): Observable<void> {
		return this.httpClient.post<void>(this.url + '/queueAssetProfileAttributeUpdate', payload);
	}

	public listAssetProfileAttributeUpdateDrafts(): Observable<AssetProfileAttributeUpdateDraftListItem[]> {
		return this.httpClient.get<AssetProfileAttributeUpdateDraftListItem[]>(this.url + '/assetProfileAttributeUpdateDrafts');
	}

	public getAssetProfileAttributeUpdateDraftPayload(id: number): Observable<string> {
		return this.httpClient.get(this.url + '/assetProfileAttributeUpdateDraft/' + id + '/payload', {
			responseType: 'text',
		});
	}

	public saveAssetProfileAttributeUpdateDraft(body: {
		id?: number | null;
		displayName: string;
		payloadJson: string;
	}): Observable<{ id: number }> {
		return this.httpClient.post<{ id: number }>(this.url + '/assetProfileAttributeUpdateDraft', body);
	}

	public deleteAssetProfileAttributeUpdateDraft(id: number): Observable<void> {
		return this.httpClient.delete<void>(this.url + '/assetProfileAttributeUpdateDraft/' + id);
	}

	public getByCustomerId(customerId: number, leaseId: number): Observable<Railcar[]> {
		if (leaseId) {
			return this.httpClient.get<Railcar[]>(this.url + '/getByCustomerId?id=' + customerId + '&leaseId=' + leaseId);
		} else {
			return this.httpClient.get<Railcar[]>(this.url + '/getByCustomerId?id=' + customerId);
		}
	}

	public processExpenseValue(path:string, type:ExpenseType, period:Date,  isValidate:boolean){
		return this.httpClient.get<any>(this.url + '/processExpenseFile?isValidate='+isValidate+'&path='+path+'&type='+type+'&period='+period.toLocaleDateString());
	}

	public processBookValue(path: string, isValidate: boolean): Observable<any> {
		return this.httpClient.get<any>(this.url + '/processBookValue?path=' + path + '&isValidate=' + isValidate);
	}

	public allocateInterestExpense(interestExpenseAmount: number, period: Date) {
		return this.httpClient.get<any>(this.url + '/allocateInterestExpense?interestExpenseAmount=' + interestExpenseAmount
			+ '&period=' + period.toLocaleDateString());
	}

	public getRailCarsByCustomerId(customerId: number): Observable<any> {
		return this.httpClient.get<any>(this.url + '/getRailCarsByCustomerId?customerId=' + customerId);
	}

	public getRailcarSearchDefaultColumns() {
		return [
			{ key: 'leaseType', value: 'Lease Type' },
			{ key: 'statusEffectiveDate', value: 'Status Effective Date' },
			{ key: 'availabilityCode', value: 'Availability Code' },
			{ key: 'appraisalValue',	value: 'Appraisal Value' },
			{ key: 'customerName', value: 'Customer Name' },
			{ key: 'rider', value: 'Lease #' },
			{ key: 'pendingLease', value: 'Pending Lease #' },
			{ key: 'leaseRate', value: 'Lease Rate' },
			{ key: 'leaseExpiration', value: 'Lease Expiration' },
			{ key: 'cpDate', value: 'CP Date' },
			{ key: 'storageLocation', value: 'Storage Location' },
			{ key: 'dateInStorage', value: 'Date In Storage' },
			{ key: 'ownershipCode', value: 'Ownership Code' },
			{ key: 'superGroup', value: 'Car Super Group' },
			{ key: 'carGroupI', value: 'Car Group I' },
			{ key: 'carGroupII', value: 'Car Group II' },
			{ key: 'carType', value: 'AAR Car Type Code' },
			{ key: 'cubeType', value: 'Cube Type' },
			{ key: 'commodity', value: 'Commodity' },
			{ key: 'bookValue', value: 'Book Value' },
			{ key: 'isPendingApproval', value: 'Pending Customer Approval' },
			{ key: 'previousCarMark', value: 'Previous Car Mark' },
			{ key: 'purchaseDate', value: 'Purchase Date' },
			{ key: 'purchaseDate_MMYYYY', value: 'Purchase Date_MM YYYY' },
			{ key: 'deathDate', value: 'Death Date' }
		]
	}

	public getRailcarSLBTermSearchColumns() {
		return [
			{ key: 'slbCode',	value: 'SLB Code' },
			{ key: 'slbOriginalAmount',	value: 'Original Amount' },
			{ key: 'slbInceptionDate',	value: 'Inception Date' },
			{ key: 'slbRentAmount',	value: 'Rent Amount' },
			{ key: 'slbMaturityDate',	value: 'Maturity Date' },
			{ key: 'slbMaturityTerm',	value: 'Maturity Term' },
			{ key: 'slbEboTerm',	value: 'EBO Term' },
			{ key: 'slbEboConditions',	value: 'EBO Conditions' },
			{ key: 'slbEboDate',	value: 'EBO Date' },
			{ key: 'slbEboPercentage',	value: 'EBO Percentage' },
			{ key: 'slbEboAmount',	value: 'EBO Amount' },
			{ key: 'slbEboInterestrate',	value: 'EBO Interest Rate' },
			{ key: 'slbRestockingFeeExists',	value: 'Restocking Fee Exists' },
			{ key: 'slbRestockingFeePercentage',	value: 'Restocking Fee Percentage' },
			{ key: 'slbRestockingFee',	value: 'Restocking Fee' },
			{ key: 'slbReturnStorageOfEquipment',	value: 'Return Storage Of Equipment' },
			{ key: 'slbPurchaseOptionConditions',	value: 'Purchase Option Conditions' },
			{ key: 'slbRenewalOptionConditions',	value: 'Renewal Option Conditions' },
			{ key: 'slbSubleaseConditions',	value: 'Sublease Conditions' },
			{ key: 'slbComplianceConditions',	value: 'Compliance Conditions' }
		]
	}

	public getAssetProfileFreightAttributes()
	{
		return [
			//covered hopper
			{ key: 'Exterior Paint MFG.',			value: 'Exterior Paint MFG.' },
			{ key: 'Shop Exterior Paint Applied',	value: 'Shop Exterior Paint Applied' },
			{ key: 'Exterior Painted Date',			value: 'Exterior Painted Date' },
			{ key: 'Gate Size',						value: 'Gate Size' },
			{ key: 'Gate Attached',					value: 'Gate Attached' },
			{ key: 'Gate Clearance in Inches',		value: 'Gate Clearance in Inches' },
			{ key: 'Gate Material',					value: 'Gate Material' },
			{ key: 'Gate A',						value: 'Gate A' },
			{ key: 'Gate MFG A',					value: 'Gate MFG A' },
			{ key: 'Gate B',						value: 'Gate B' },
			{ key: 'Gate MFG B',					value: 'Gate MFG B' },
			{ key: 'Gate C',						value: 'Gate C' },
			{ key: 'Gate MFG C',					value: 'Gate MFG C' },
			{ key: 'Gate AC',						value: 'Gate AC' },
			{ key: 'Gate MFG AC',					value: 'Gate MFG AC' },
			{ key: 'Gate BC',						value: 'Gate BC' },
			{ key: 'Gate MFG BC',					value: 'Gate MFG BC' },
			{ key: 'Bee Vents',						value: 'Bee Vents' },
			{ key: 'Type of Hatch Covers',			value: 'Type of Hatch Covers' },
			{ key: 'Number of Covers',				value: 'Number of Covers' },
			{ key: 'Hatch Cover Material',			value: 'Hatch Cover Material' },
			{ key: 'Hatch Covers Vented',			value: 'Hatch Covers Vented' },
			{ key: 'Lined',							value: 'Lined' },
			{ key: 'Lining',						value: 'Lining' },
			{ key: 'Lining Color',					value: 'Lining Color' },
			{ key: 'Lining Applied By',			value: 'Lining Applied By' },
			{ key: 'Pressure Discharge Car',		value: 'Pressure Discharge Car' },
      		{ key: 'Type of Sill Covered Hopper',value: 'Type of Sill Covered Hopper' },
      		{ key: 'Lining Applied Date',value: 'Lining Applied Date' }
		]};

	public getAssetProfileTankAttributes()
	{
		return [
			//tank car attributes
			{ key: 'Tank Specification', 						value:'Tank Specification'}
			,{ key: 'Stenciled Specification',                  value:'Stenciled Specification'}
			,{ key: 'Est Light Weight/Gallon',                  value:'Est Light Weight/Gallon'}
			,{ key: 'Max Gross Weight/Gallon',                  value:'Max Gross Weight/Gallon'}
			,{ key: 'Tank Qualified By',                        value:'Tank Qualified By'}
			,{ key: 'Inspection Date',                          value:'Inspection Date'}
			,{ key: 'Inspection Due Date',                      value:'Inspection Due Date'}
			,{ key: 'Thickness Tested By',                      value:'Thickness Tested By'}
			,{ key: 'Thickness Tested Date',                    value:'Thickness Tested Date'}
			,{ key: 'Thickness Test Due Date',                  value:'Thickness Test Due Date'}
			,{ key: 'Service Equipment Inspected By',           value:'Service Equipment Inspected By'}
			,{ key: 'Service Equipment Inspection Date',        value:'Service Equipment Inspection Date'}
			,{ key: 'Service Equipment Inspection Due',         value:'Service Equipment Inspection Due'}
			,{ key: 'Pressure Relief Valve',                    value:'Pressure Relief Valve'}
			,{ key: 'Pressure Relief Valve Applied By',			    value:'Pressure Relief Valve Applied By'}
			,{ key: 'Pressure Relieve Valve Date Applied',      value:'Pressure Relieve Valve Date Applied'}
			,{ key: 'Pressure Relief Valve Due Date',           value:'Pressure Relief Valve Due Date'}
			,{ key: '88.B.2 Inspection Done By',                value:'88.B.2 Inspection Done By'}
			,{ key: '88.B.2 Inspection Date',                   value:'88.B.2 Inspection Date'}
			,{ key: '88.B.2 Inspection Due Date',               value:'88.B.2 Inspection Due Date'}
			,{ key: 'Stub Sill Inspection Done By',             value:'Stub Sill Inspection Done By'}
			,{ key: 'Stub Sill Inspection Date',                value:'Stub Sill Inspection Date'}
			,{ key: 'Stub Sill Inspection Due Date',            value:'Stub Sill Inspection Due Date'}
			,{ key: 'Lined',                                    value:'Lined'}
			,{ key: 'Lining',                                   value:'Lining'}
			,{ key: 'Lining Applied By',                        value:'Lining Applied By'}
			,{ key: 'Lining Due Date',                          value:'Lining Due Date'}
			,{ key: 'Paint',                                    value:'Paint'}
			,{ key: 'Exterior Paint Date',                      value:'Exterior Paint Date'}
			,{ key: 'Stencil',                                  value:'Stencil'}
			,{ key: 'Outage Scale',                             value:'Outage Scale'}
			,{ key: 'Protective Housing',                       value:'Protective Housing'}
			,{ key: 'Fittings Nozzle Gasket',                   value:'Fittings Nozzle Gasket'}
			,{ key: 'Air Valve Manufacturer',                   value:'Air Valve Manufacturer'}
			,{ key: 'Air Valve Model',                          value:'Air Valve Model'}
			,{ key: 'Air Valve Connection Size',                value:'Air Valve Connection Size'}
			,{ key: 'Air/Discharge Gasket',                     value:'Air/Discharge Gasket'}
			,{ key: 'Air/Discharge O-Ring',                     value:'Air/Discharge O-Ring'}
			,{ key: 'Loading Valve Manufacturer',               value:'Loading Valve Manufacturer'}
			,{ key: 'Loading Valve Model',                      value:'Loading Valve Model'}
			,{ key: 'Loading Valve Size',                       value:'Loading Valve Size'}
			,{ key: 'Eduction Pipe Size',                       value:'Eduction Pipe Size'}
			,{ key: 'Gauge Device Manufacturer',                value:'Gauge Device Manufacturer'}
			,{ key: 'Gauge Device Model',                       value:'Gauge Device Model'}
			,{ key: 'PRD Manufacturer',                         value:'PRD Manufacturer'}
			,{ key: 'PRD Model',                                value:'PRD Model'}
			,{ key: 'PRD Material',                             value:'PRD Material'}
			,{ key: 'Safety Relief Gasket',                     value:'Safety Relief Gasket'}
			,{ key: 'Safety Relief O-Ring',                     value:'Safety Relief O-Ring'}
			,{ key: 'Sample Line Model',                        value:'Sample Line Model'}
			,{ key: 'Sample Line Size',                         value:'Sample Line Size'}
			,{ key: 'Thermowell',                               value:'Thermowell'}
			,{ key: 'Thermowell Manufacturer',                  value:'Thermowell Manufacturer'}
			,{ key: 'Thermowell Model',                         value:'Thermowell Model'}
			,{ key: 'Thermowell/Sample/Gage Gasket',            value:'Thermowell/Sample/Gage Gasket'}
			,{ key: 'Thermowell/Sample/Gage O-Ring',            value:'Thermowell/Sample/Gage O-Ring'}
			,{ key: 'Vacuum Relief Device Manufacturer',        value:'Vacuum Relief Device Manufacturer'}
			,{ key: 'Vacuum Relief Device Model Number',        value:'Vacuum Relief Device Model Number'}
			,{ key: 'Vacuum Relief Device Material',            value:'Vacuum Relief Device Material'}
			,{ key: 'Vacuum Relief Valve Rating (psi)',         value:'Vacuum Relief Valve Rating (psi)'}
			,{ key: 'Vacuum Relief Gasket',                     value:'Vacuum Relief Gasket'}
			,{ key: 'Vacuum Relief O-Ring',                     value:'Vacuum Relief O-Ring'}
			,{ key: 'Manway',                                   value:'Manway'}
			,{ key: 'Manway Cover Top Fittings',                value:'Manway Cover Top Fittings'}
			,{ key: 'Manway Cover Gasket',                      value:'Manway Cover Gasket'}
			,{ key: 'Discharge Connection Manufacturer',        value:'Discharge Connection Manufacturer'}
			,{ key: 'Discharge Connection Model Number ',       value:'Discharge Connection Model Number '}
			,{ key: 'Discharge Connection Size',                value:'Discharge Connection Size'}
			,{ key: 'Discharge Connection Material',            value:'Discharge Connection Material'}
			,{ key: 'Outlet - Fittings',                        value:'Outlet - Fittings'}
			,{ key: 'Bottom Outlet Valve Handle',               value:'Bottom Outlet Valve Handle'}
			,{ key: 'Outlet Valve Gaskets',                     value:'Outlet Valve Gaskets'}
			,{ key: 'Outlet Valve O-Ring',                      value:'Outlet Valve O-Ring'}
			,{ key: 'Outlet Nozzle/Cap Gasket',                 value:'Outlet Nozzle/Cap Gasket'}
			,{ key: 'Outlet Nozzle/Cap O-Ring',                 value:'Outlet Nozzle/Cap O-Ring'}
			,{ key: 'Side Bearings',                            value:'Side Bearings'}
			,{ key: 'Conduit for ECP Brakes Tank',              value:'Conduit for ECP Brakes Tank'}
			,{ key: 'Empty Load Brakes',                        value:'Empty Load Brakes'}
		]
	}

	public getUmlerAttributes() {
		return [
			{ key: 'Equipment Id',										value: '0001: Equipment Id' },
			{ key: 'Slack Adjuster CID',								value: 'B359: Slack Adjuster CID' },
			{ key: 'Air Brake Test Device',								value: 'B523: Air Brake Test Device' },
			{ key: 'Slack Adjuster Group',								value: 'B538: Slack Adjuster Group' },
			{ key: '4-Port ABT Receiver Eqpd',							value: 'B539: 4-Port ABT Receiver Eqpd' },
			{ key: 'Brake Cylinder Mount Type',							value: 'B540: Brake Cylinder Mount Type' },
			{ key: 'Jacket Thickness',									value: 'B541: Jacket Thickness' },
			{ key: 'Bottom Outlet Valve Type',							value: 'B542: Bottom Outlet Valve Type' },
			{ key: 'Btm Outlet Vlv Actuation',							value: 'B543: Btm Outlet Vlv Actuation' },
			{ key: 'Non-Compliant Wheelsets',							value: 'B544: Non-Compliant Wheelsets' },
			{ key: 'Pseudo Equipment Group',							value: 'B547: Pseudo Equipment Group' },
			{ key: 'Loaded Net Braking Ratio',							value: 'B551: Loaded Net Braking Ratio' },
			{ key: 'Owner-Provided Loaded Net Braking Ratio',			value: 'B552: Owner-Provided Loaded Net Braking Ratio' },
			{ key: 'Empty Braking Ratio',								value: 'B553: Empty Braking Ratio' },
			{ key: 'Owner-Provided Empty Braking Ratio',				value: 'B554: Owner-Provided Empty Braking Ratio' },
			{ key: 'Thermal Protection System',							value: 'B555: Thermal Protection System' },
			{ key: 'Draft Gear/Cushion Unit Group',						value: 'B562: Draft Gear/Cushion Unit Group' },
			{ key: 'Draft Gear/Cushion Unit Type',						value: 'B563: Draft Gear/Cushion Unit Type' },
			{ key: 'Inspection Certified by',							value: 'CERT: Inspection Certified by' },
			{ key: 'Car Grade',											value: 'CG01: Car Grade' },
			{ key: 'Car Grade Inspection Date',							value: 'CG02: Car Grade Inspection Date' },
			{ key: 'Car Grade Inspection Time',							value: 'CG03: Car Grade Inspection Time' },
			{ key: 'Car Grade Location SPLC',							value: 'CG04: Car Grade Location SPLC' },
			{ key: 'Car Grade Inspection SCAC',							value: 'CG05: Car Grade Inspection SCAC' },
			{ key: 'Inspection Conducted by',							value: 'COND: Inspection Conducted by' },
			{ key: 'FRA Drop Dead Date',								value: 'DDNE: FRA Drop Dead Date' },
			{ key: 'Inspection Date Done',								value: 'DTDN: Inspection Date Done' },
			{ key: 'ABT 12-24 Month Due Date',							value: 'DU13: ABT 12-24 Month Due Date' },
			{ key: 'ABT 5/8-Year Due Date',								value: 'DU58: ABT 5/8-Year Due Date' },
			{ key: 'Inspection Due Date',								value: 'INDD: Inspection Due Date' },
			{ key: 'Inspection Item Codes',								value: 'L003: Inspection Item Codes' },
			{ key: 'Air Card Item',										value: 'L015: Air Card Item' },
			{ key: 'Air Card Description',								value: 'L016: Air Card Description' },
			{ key: 'Air Card Frequency Days',							value: 'L017: Air Card Frequency Days' },
			{ key: 'Inspection Performer',								value: 'PERF: Inspection Performer' },
			{ key: 'Inspection Reporter',								value: 'REPT: Inspection Reporter' },
			{ key: 'Scheduled Due Date',								value: 'SCDD: Scheduled Due Date' },
			{ key: 'Location/SPLC',										value: 'SPLC: Location/SPLC' },
			{ key: 'A&B Pos/Neg Ind',									value: 'A316: A&B Pos/Neg Ind' },
			{ key: 'A&B Amount',										value: 'A317: A&B Amount' },
			{ key: 'A&B Type',											value: 'A318: A&B Type' },
			{ key: 'A&B Date Done',										value: 'A319: A&B Date Done' },
			{ key: 'Axles Spacing Distance',							value: 'B020: Axles Spacing Distance' },
			{ key: 'Equipment Group',									value: '0002: Equipment Group' },
			{ key: 'Total A&B',											value: 'A003: Total A&B' },
			{ key: 'Connected Unit Count',								value: 'A020: Connected Unit Count' },
			{ key: 'Axle Count',										value: 'A024: Axle Count' },
			{ key: 'Body Material',										value: 'A030: Body Material' },
			{ key: 'Equipment Builder',									value: 'A035: Equipment Builder' },
			{ key: 'Center of Gravity Empty',							value: 'A045: Center of Gravity Empty' },
			{ key: 'Plate Code',										value: 'A046: Plate Code' },
			{ key: 'Compartment Count',									value: 'A052: Compartment Count' },
			{ key: 'Permanent Container Material',						value: 'A055: Permanent Container Material' },
			{ key: 'Cubic Feet Capacity',								value: 'A067: Cubic Feet Capacity' },
			{ key: 'Rate Indicator',									value: 'A070: Rate Indicator' },
			{ key: 'Degree of Slope Sheets',							value: 'A071: Degree of Slope Sheets' },
			{ key: 'Design Shipping Cont Spec',							value: 'A072: Design Shipping Cont Spec' },
			{ key: 'End Door Height',									value: 'A080: End Door Height' },
			{ key: 'End Door Width',									value: 'A082: End Door Width' },
			{ key: 'End-Swing Offset (ESO)',							value: 'A084: End-Swing Offset (ESO)' },
			{ key: 'Extended Service',									value: 'A096: Extended Service' },
			{ key: 'Floor Cradle/Trough Equipped',						value: 'A103: Floor Cradle/Trough Equipped' },
			{ key: 'Floor Material',									value: 'A104: Floor Material' },
			{ key: 'Head Protection Type',								value: 'A118: Head Protection Type' },
			{ key: 'Ind for Pos/Neg Total A&B',							value: 'A128: Ind for Pos/Neg Total A&B' },
			{ key: 'Inset Stake Pkts Plat Len',							value: 'A131: Inset Stake Pkts Plat Len' },
			{ key: 'Inset Stake Pkts Plat Wdt',							value: 'A132: Inset Stake Pkts Plat Wdt' },
			{ key: 'Inside Height',										value: 'A133: Inside Height' },
			{ key: 'Inside Length',										value: 'A135: Inside Length' },
			{ key: 'Inside Width',										value: 'A138: Inside Width' },
			{ key: 'Insulation Type',									value: 'A142: Insulation Type' },
			{ key: 'CC Side Bearing Type',								value: 'A146: CC Side Bearing Type' },
			{ key: 'Ledger Value',										value: 'A150: Ledger Value' },
			{ key: 'Bottom Fitting Protection',							value: 'A153: Bottom Fitting Protection' },
			{ key: 'Lining Material',									value: 'A158: Lining Material' },
			{ key: 'Mid-ordinate Offset (MOO)',							value: 'A167: Mid-ordinate Offset (MOO)' },
			{ key: 'Safety Relief Device Cnt',							value: 'A181: Safety Relief Device Cnt' },
			{ key: 'Operating Brakes',									value: 'A182: Operating Brakes' },
			{ key: 'Orig Cert of Constr Nbr',							value: 'A183: Orig Cert of Constr Nbr' },
			{ key: 'Original Cost',										value: 'A184: Original Cost' },
			{ key: 'Outside Extreme Height',							value: 'A185: Outside Extreme Height' },
			{ key: 'Outside Extreme Width',								value: 'A186: Outside Extreme Width' },
			{ key: 'Outside Height Extr Width',							value: 'A187: Outside Height Extr Width' },
			{ key: 'Outside Lower Eaves Hght',							value: 'A189: Outside Lower Eaves Hght' },
			{ key: 'Outside Lower Eaves Width',							value: 'A190: Outside Lower Eaves Width' },
			{ key: 'Platform Hght Above Rail',							value: 'A192: Platform Hght Above Rail' },
			{ key: 'Outside Upper Eaves Hght',							value: 'A193: Outside Upper Eaves Hght' },
			{ key: 'Outside Upper Eaves Width',							value: 'A194: Outside Upper Eaves Width' },
			{ key: 'Roof Type',											value: 'A226: Roof Type' },
			{ key: 'Safety Relief Device Type',							value: 'A230: Safety Relief Device Type' },
			{ key: 'Safety Vent w/Surge Prot',					value: 'A231: Safety Vent w/Surge Prot' },
			{ key: 'Stenciled Shipping Spec',		value: 'A237: Stenciled Shipping Spec' },
			{ key: 'Star Code',											value: 'A247: Star Code' },
			{ key: 'Stub Sill Design Type',								value: 'A251: Stub Sill Design Type' },
			{ key: 'Tank Head Mat Spec',		value: 'A254: Tank Head Mat Spec' },
			{ key: 'Tank Head Thickness',								value: 'A255: Tank Head Thickness' },
			{ key: 'Tank Shell Material Spec',					value: 'A257: Tank Shell Material Spec' },
			{ key: 'Tank Shell Thickness',								value: 'A258: Tank Shell Thickness' },
			{ key: 'Tare Weight',										value: 'A259: Tare Weight' },
			{ key: 'Top Fittings Protection',							value: 'A264: Top Fittings Protection' },
			{ key: 'Gross Rail Load/Weight',						value: 'A266: Gross Rail Load/Weight' },
			{ key: 'Truck Center Length',								value: 'A276: Truck Center Length' },
			{ key: 'Weighing Date',										value: 'A288: Weighing Date' },
			{ key: 'Weighing Status',									value: 'A289: Weighing Status' },
			{ key: 'Gallonage Capacity',								value: 'A297: Gallonage Capacity' },
			{ key: 'Tank Built Date',									value: 'A298: Tank Built Date' },
			{ key: 'Bottom Outlet/Fitting Typ',						value: 'A308: Bottom Outlet/Fitting Typ' },
			{ key: 'Tank Lining Material',								value: 'A315: Tank Lining Material' },
			{ key: 'AEI High Temperature Tag',					value: 'B006: AEI High Temperature Tag' },
			{ key: 'Bearing Shielded from Hot Box Detector',			value: 'B021: Bearing Shielded from Hot Box Detector' },
			{ key: 'Brake Shoe Type',									value: 'B026: Brake Shoe Type' },
			{ key: 'Bridge Plate Type',									value: 'B029: Bridge Plate Type' },
			{ key: 'Builder Lot Code',									value: 'B030: Builder Lot Code' },
			{ key: 'Built Country',										value: 'B031: Built Country' },
			{ key: 'Bulkhead Type',										value: 'B034: Bulkhead Type' },
			{ key: 'Bulkhd Height Abov Pltfrm',					value: 'B035: Bulkhd Height Abov Pltfrm' },
			{ key: 'Bulkhead Top Width',								value: 'B038: Bulkhead Top Width' },
			{ key: 'Center and Middle Stake Pocket Equipped',			value: 'B040: Center and Middle Stake Pocket Equipped' },
			{ key: 'Check trailing tonnage',							value: 'B044: Check trailing tonnage' },
			{ key: 'Commercial Lessee CIF',								value: 'B048: Commercial Lessee CIF' },
			{ key: 'Commercial Owner CIF',								value: 'B049: Commercial Owner CIF' },
			{ key: 'Conflict Status',									value: 'B050: Conflict Status' },
			{ key: 'Permanent Container Top Height Above Platform',		value: 'B052: Permanent Container Top Height Above Platform' },
			{ key: 'Container Permanently Attached',					value: 'B054: Container Permanently Attached' },
			{ key: 'Permanent Container Top Width',						value: 'B056: Permanent Container Top Width' },
			{ key: 'Removable Cover Equipped',							value: 'B060: Removable Cover Equipped' },
			{ key: 'Conflict Status Next Date',						value: 'B062: Conflict Status Next Date' },
			{ key: 'Date of Original Conflict',					value: 'B063: Date of Original Conflict' },
			{ key: 'Delete Reason Code',								value: 'B064: Delete Reason Code' },
			{ key: 'Depressed or Well Flat Bottom Length',				value: 'B065: Depressed or Well Flat Bottom Length' },
			{ key: 'Depressed or Well Flat Bottom Width',				value: 'B066: Depressed or Well Flat Bottom Width' },
			{ key: 'Depressed or Well Flat Top Length',					value: 'B067: Depressed or Well Flat Top Length' },
			{ key: 'Depressed or Well Flat Top Width',					value: 'B068: Depressed or Well Flat Top Width' },
			{ key: 'EIN Duplication Flag',								value: 'B074: EIN Duplication Flag' },
			{ key: 'Empty/Load Device Eqpd',						value: 'B075: Empty/Load Device Eqpd' },
			{ key: 'End of Service Date',								value: 'B078: End of Service Date' },
			{ key: 'Equipment Add Date',								value: 'B082: Equipment Add Date' },
			{ key: 'Equipment Add Reporter Company',					value: 'B083: Equipment Add Reporter Company' },
			{ key: 'Floor Cradle/Trough Orientation',					value: 'B093: Floor Cradle/Trough Orientation' },
			{ key: 'Gondola Floor Design',								value: 'B094: Gondola Floor Design' },
			{ key: 'FRA Reflectorization',								value: 'B096: FRA Reflectorization' },
			{ key: '286K Aprvd COC/FRA Waiver',							value: 'B098: 286K Aprvd COC/FRA Waiver' },
			{ key: 'Gondola with Drop Ends',							value: 'B103: Gondola with Drop Ends' },
			{ key: 'Head Protection Thickness',							value: 'B105: Head Protection Thickness' },
			{ key: 'High Speed Design',									value: 'B109: High Speed Design' },
			{ key: 'Interior Rack',										value: 'B114: Interior Rack' },
			{ key: 'Intermediate Connector Style',						value: 'B115: Intermediate Connector Style' },
			{ key: 'Lading Strap Anchor Eqpd',						value: 'B121: Lading Strap Anchor Eqpd' },
			{ key: 'Last Update Date',									value: 'B122: Last Update Date' },
			{ key: 'Light Density',										value: 'B124: Light Density' },
			{ key: 'Coil Steel/Aluminum Loading',						value: 'B132: Coil Steel/Aluminum Loading' },
			{ key: 'Next Conflict Status',								value: 'B135: Next Conflict Status' },
			{ key: 'Non-Fish Belly',									value: 'B136: Non-Fish Belly' },
			{ key: 'Notice Management Indicator',						value: 'B137: Notice Management Indicator' },
			{ key: 'Bottom Outlet Count',								value: 'B142: Bottom Outlet Count' },
			{ key: 'Private Zero Rate',									value: 'B150: Private Zero Rate' },
			{ key: 'Rebuilt Country',									value: 'B170: Rebuilt Country' },
			{ key: 'Registration Reason',								value: 'B174: Registration Reason' },
			{ key: 'Remote Monitoring Device',					value: 'B176: Remote Monitoring Device' },
			{ key: 'Restencil Program Ind',						value: 'B177: Restencil Program Ind' },
			{ key: 'Curve Negotiability Exception',						value: 'B178: Curve Negotiability Exception' },
			{ key: 'Restricted Speed When Empty',						value: 'B180: Restricted Speed When Empty' },
			{ key: 'Restricted Speed When Loaded',						value: 'B181: Restricted Speed When Loaded' },
			{ key: 'Shove adjacent car to rest',						value: 'B188: Shove adjacent car to rest' },
			{ key: 'Shove car to rest',									value: 'B189: Shove car to rest' },
			{ key: 'Stake Pockets (side/end)',				value: 'B190: Stake Pockets (side/end)' },
			{ key: 'Wheel Bearing Type',								value: 'B191: Wheel Bearing Type' },
			{ key: 'Spring Tensioning Device',							value: 'B198: Spring Tensioning Device' },
			{ key: 'Steel Riser Equipped',								value: 'B200: Steel Riser Equipped' },
			{ key: 'Mark Owner Category',					value: 'B201: Mark Owner Category' },
			{ key: 'Tank Head Material Norm',						value: 'B203: Tank Head Material Norm' },
			{ key: 'Tank Jacket Material',								value: 'B204: Tank Jacket Material' },
			{ key: 'Tank Major Class',						value: 'B207: Tank Major Class' },
			{ key: 'TankShell Material Norm',					value: 'B208: TankShell Material Norm' },
			{ key: 'Train Position Sensitive',							value: 'B211: Train Position Sensitive' },
			{ key: 'TTX Hourly Rate',									value: 'B212: TTX Hourly Rate' },
			{ key: 'TTX Mileage Rate',									value: 'B213: TTX Mileage Rate' },
			{ key: 'Unloading System Type',						value: 'B220: Unloading System Type' },
			{ key: 'Vibrator Bracket Equipped',							value: 'B223: Vibrator Bracket Equipped' },
			{ key: 'Automatic Unloading Device Equipped (Non-LO)',		value: 'B224: Automatic Unloading Device Equipped (Non-LO)' },
			{ key: 'Wood Racks, Covering Floors',						value: 'B233: Wood Racks, Covering Floors' },
			{ key: 'Height of Depressed Platform above Rail',			value: 'B239: Height of Depressed Platform above Rail' },
			{ key: 'Year Tank Qualified',								value: 'B240: Year Tank Qualified' },
			{ key: 'Tank Qualification Due',						value: 'B241: Tank Qualification Due' },
			{ key: 'Service Equip Qualified',					value: 'B242: Service Equip Qualified' },
			{ key: 'Service Equipment Due',						value: 'B243: Service Equipment Due' },
			{ key: 'Pressure Relief Qualified',					value: 'B244: Pressure Relief Qualified' },
			{ key: 'Pressure Relief Due',						value: 'B245: Pressure Relief Due' },
			{ key: 'Thickness Qualified Year',					value: 'B246: Thickness Qualified Year' },
			{ key: 'Thickness Qualified Due',					value: 'B247: Thickness Qualified Due' },
			{ key: 'Truck Count',										value: 'B256: Truck Count' },
			{ key: 'Insulation Thickness',			value: 'B259: Insulation Thickness' },
			{ key: 'Canopy Equipped',									value: 'B266: Canopy Equipped' },
			{ key: 'Chains and Binders Equipped',						value: 'B267: Chains and Binders Equipped' },
			{ key: 'Cross Bar Equipped',								value: 'B268: Cross Bar Equipped' },
			{ key: 'Blocking Timbers Equipped',							value: 'B270: Blocking Timbers Equipped' },
			{ key: 'Tie Down Assembly Non-FA',					value: 'B271: Tie Down Assembly Non-FA' },
			{ key: 'Cooper Rating Exception',							value: 'B273: Cooper Rating Exception' },
			{ key: 'Clearance Exception',								value: 'B275: Clearance Exception' },
			{ key: 'Position on the rearmost end of train only',		value: 'B277: Position on the rearmost end of train only' },
			{ key: 'Do not couple to top shelf couplers or locomotives',value: 'B278: Do not couple to top shelf couplers or locomotives' },
			{ key: 'PWHT Tank Car Re-stress Relieved',					value: 'B279: PWHT Tank Car Re-stress Relieved' },
			{ key: 'PWHT Tank Car Not Re-worked',						value: 'B280: PWHT Tank Car Not Re-worked' },
			{ key: 'Tie-Down Strap Equipped',							value: 'B282: Tie-Down Strap Equipped' },
			{ key: 'TOFC/COFC Load Wdth Cde',							value: 'B283: TOFC/COFC Load Wdth Cde' },
			{ key: 'Portable Brdge Plate Cap.',							value: 'B284: Portable Brdge Plate Cap.' },
			{ key: 'Intermodal Transport Serv',							value: 'B287: Intermodal Transport Serv' },
			{ key: 'Single Lngth Load Config',							value: 'B288: Single Lngth Load Config' },
			{ key: 'ECP Brake Type',									value: 'B327: ECP Brake Type' },
			{ key: 'ECP Brake Builder',									value: 'B328: ECP Brake Builder' },
			{ key: 'Equipment Descriptor ',								value: 'B341: Equipment Descriptor' },
			{ key: 'Qual for Inc GRL',									value: 'B344: Qual for Inc GRL' },
			{ key: 'Dedicated Service',									value: 'B346: Dedicated Service' },
			{ key: 'Info Conflict Status',								value: 'B355: Info Conflict Status' },
			{ key: 'Chain Equipped',									value: 'B402: Chain Equipped' },
			{ key: 'Maintenance of Way Service Type',					value: 'B403: Maintenance of Way Service Type' },
			{ key: 'LCS Date',											value: 'B405: LCS Date' },
			{ key: 'Railinc Notes',										value: 'B409: Railinc Notes' },
			{ key: 'CPC-1232 Compliant',								value: 'B522: CPC-1232 Compliant' },
			{ key: 'Air Hose Arrangement',								value: 'B524: Air Hose Arrangement' },
			{ key: 'Stub Sill Variation',								value: 'B526: Stub Sill Variation' },
			{ key: 'Restricted under TC-PD-34',							value: 'B527: Restricted under TC-PD-34' },
			{ key: 'Built Date',										value: 'BLDT: Built Date' },
			{ key: 'Umler Effective Date',								value: 'EFDT: Umler Effective Date' },
			{ key: 'Equipment Identification',							value: 'EINN: Equipment Identification' },
			{ key: 'Load Limit',										value: 'LDLT: Load Limit' },
			{ key: 'Lessee',											value: 'LESE: Lessee' },
			{ key: 'Maintenance Party',									value: 'MNPT: Maintenance Party' },
			{ key: 'Outside Length',									value: 'OSLG: Outside Length' },
			{ key: 'Pool Number',										value: 'P001: Pool Number' },
			{ key: 'Prior Equipment ID',								value: 'PRID: Prior Equipment ID' },
			{ key: 'Rebuilt / ILS Date',								value: 'RBDT: Rebuilt / ILS Date' },
			{ key: 'Rebuilt Flag',										value: 'RBFL: Rebuilt Flag' },
			{ key: 'Transportation Cond Code',				value: 'TCCD: Transportation Cond Code' },
			{ key: 'Sys Gen Routing Inst',				value: 'TCGR: Sys Gen Routing Inst' },
			{ key: 'Mechanical Restriction',							value: 'TCME: Mechanical Restriction' },
			{ key: 'Mech Restriction Reason',						value: 'TCMR: Mech Restriction Reason' },
			{ key: 'Umler Transportation Code',							value: 'TCOD: Umler Transportation Code' },
			{ key: 'Pool Control',										value: 'TCPC: Pool Control' },
			{ key: 'User Routing Instructions',					value: 'TCUR: User Routing Instructions' },
			{ key: 'Equipment Type Code',								value: 'UMET: Equipment Type Code' },
			{ key: 'Mechanical Designation',							value: 'UMMD: Mechanical Designation' },
			{ key: 'Owner',										value: 'UMOW: Owner' },
			{ key: 'First Movement Date',								value: 'USAT: First Movement Date' },
			{ key: 'Status Code',										value: 'USCD: Status Code' },
			{ key: 'Status Change Reason',								value: 'USCR: Status Change Reason' },
			{ key: 'Status Change Date',								value: 'USCT: Status Change Date' },
			{ key: 'Coils Exterior/Interior',							value: 'X109: Coils Exterior/Interior' },
			{ key: 'Coil Material',										value: 'X111: Coil Material' },
			{ key: 'Bolster Component ID',								value: 'B351: Bolster Component ID' },
			{ key: 'Coupler Component ID',								value: 'B353: Coupler Component ID' },
			{ key: 'Coupler Code',										value: 'A057: Coupler Code' },
			{ key: 'Coupler Style',										value: 'B058: Coupler Style' },
			{ key: 'Inches of Travel',									value: 'B061: Inches of Travel' },
			{ key: 'Draft Gear Type',									value: 'B073: Draft Gear Type' },
			{ key: 'Emergency Brake Valve CID',				value: 'B354: Emergency Brake Valve CID' },
			{ key: 'Service Brake Valve CID',					value: 'B357: Service Brake Valve CID' },
			{ key: 'Sideframe Component ID',						value: 'B352: Sideframe Component ID' },
			{ key: 'Journal Size',										value: 'A147: Journal Size' },
			{ key: 'Wheel Diameter',									value: 'A294: Wheel Diameter' },
			{ key: 'Stability Device Equipped',							value: 'B199: Stability Device Equipped' },
			{ key: 'Truck Axle Count',									value: 'B252: Truck Axle Count' },
			{ key: 'Unit Tare Weight',									value: 'A299: Unit Tare Weight' },
			{ key: 'Unit Load Limit',									value: 'A300: Unit Load Limit' },
			{ key: 'Unit Equipment Group',								value: 'A307: Unit Equipment Group' },
			{ key: 'Intermodal Loading Method',				value: 'B286: Intermodal Loading Method' },
			{ key: 'Wheelset Component ID',								value: 'B350: Wheelset Component ID' }
		]
	}

	public getCarDvStatementPdf(initial: string, number: number, noticeDate: Date, damageDate: Date, damageLocation: string, railroad?: string, fileNumber?: string) : Observable<string> {
		return this.httpClient.get(this.url + '/getCarDvStatementPdf', 
		{
			params: {
				'initial': initial,
				'number': number.toString(),
				'noticeDate': noticeDate.toDateString(),
				'damageDate': damageDate.toDateString(),
				'damageLocation': damageLocation,
				'railroad': railroad ?? '',
				'fileNumber': fileNumber?? ''
			},
			responseType: 'text' 
		});
	}
	public getDvStatement(initial: string, number: number, noticeDate: Date, damageDate: Date) : Observable<any> {
		return this.httpClient.get(this.url + '/GetDvStatementJson', 
		{
			params: {
				'initial': initial,
				'number': number.toString(),
				'noticeDate': noticeDate.toDateString(),
				'damageDate': damageDate.toDateString()
			}
		});
	}
	public getCarSLBTerms(carId: number) : Observable<any> {
		return this.httpClient.get<any>(this.url + '/GetRailcarSLBTerms', 
		{
			params: {
				'carId': carId.toString()
			}
		});
	}

	public getRailcar(railcarId: number): Observable<Railcar> {
		return this.httpClient.get<Railcar>(this.url + '/' + railcarId);
	}

	public getPreviousCarMarkById(railcarId: number): Observable<any> {
		return this.httpClient.get<any>(this.url + '/GetPreviousCarMarkById?id=' + railcarId);
	}

	public getRailcarSuperGroup() :Observable<RailcarSuperGroup[]>{
		return this.httpClient.get<RailcarSuperGroup[]>(this.url + '/getRailcarSuperGroup');
	}

	public getRailcarTypes() :Observable<any>{
		return this.httpClient.get<any>(this.url + '/getRailcarTypes');
	}

	public getStatus() :Observable<RailcarStatus[]>{
		return this.httpClient.get<RailcarStatus[]>(this.url + '/getStatus');
	}
	
	public addRailCars(railcarList: Railcar[], fileName: string): Observable<Railcar[]> {
		return this.httpClient.post<Railcar[]>(this.url + '/AddRailCars?fileName=' + fileName, railcarList);
	}
	public getCarTypes() :Observable<any[]>{
		return this.httpClient.get<any[]>(this.url + '/getCarTypes');
	}
	public getCarCubeTypes() :Observable<any[]>{
		return this.httpClient.get<any[]>(this.url + '/getCarCubeTypes');
	}
	public getGradeTypes() :Observable<any[]>{
		return this.httpClient.get<any[]>(this.url + '/getGradeTypes');
	}
	public getRemarkedCarsData(processingMonth: Date): Observable<CarMarks[]>{
		return this.httpClient.get<CarMarks[]>(this.url + '/getRemarkedCarsData?processingMonth=' + processingMonth.toLocaleDateString());
	}

	public miscUpdate(railcarIds : number[], pendingCustomerApproval : boolean) : Observable<any>{
		return this.httpClient.post<any>(this.url + '/miscUpdate?pendingCustomerApproval=' + pendingCustomerApproval, railcarIds);
	}

	public processAppraisalValue(path: string, isValidate: boolean): Observable<any> {
		return this.httpClient.get<any>(this.url + '/processAppraisalValue?path=' + path + '&isValidate=' + isValidate);
	}

	/** First worksheet as string rows (server NPOI). Asset Profile Attribute Update bulk import. */
	public parseAssetProfileBulkImportWorkbook(file: File): Observable<string[][]> {
		const fd = new FormData();
		fd.append('Files', file, file.name);
		return this.httpClient.post<string[][]>(this.url + '/ParseAssetProfileBulkImportWorkbook', fd);
	}
}
